// VersionCheck — kesan build baru tanpa perlu clear cache manual.
// Membandingkan BUILD_ID yang dibakar dalam bundle dengan /version.json
// terkini (no-cache). Jika berbeza, papar banner "versi baru" + butang muat ulang.
// Semakan: sekali semasa mount, setiap 5 minit, dan setiap kali tab kembali fokus.
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';
import { BUILD_ID } from '../generatedBuildId';

export default function VersionCheck() {
  const { t } = useTranslation();
  const [baru, setBaru] = useState(false);

  useEffect(() => {
    let stop = false;
    const cek = async () => {
      if (process.env.NODE_ENV !== 'production' || BUILD_ID === 'dev') return; // mod dev: tiada version.json
      try {
        const r = await fetch('/version.json', { cache: 'no-store' });
        if (!r.ok) return;
        const j = await r.json();
        if (j && j.buildId && j.buildId !== BUILD_ID && !stop) setBaru(true);
      } catch {
        /* luar talian / gagal fetch — cuba lagi nanti */
      }
    };
    cek();
    const iv = setInterval(cek, 5 * 60 * 1000);
    const onVis = () => { if (document.visibilityState === 'visible') cek(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { stop = true; clearInterval(iv); document.removeEventListener('visibilitychange', onVis); };
  }, []);

  if (!baru) return null;
  return (
    <div className="fixed bottom-4 inset-x-4 z-[100] mx-auto max-w-md">
      <div className="flex items-center gap-3 rounded-2xl border border-brand/30 bg-card px-4 py-3 text-foreground shadow-xl">
        <p className="flex-1 text-sm font-medium">{t('versiBaru')}</p>
        <button
          onClick={() => window.location.reload()}
          className="inline-flex h-9 shrink-0 items-center gap-1.5 rounded-xl bg-amber-500 hover:bg-amber-600 px-3 text-sm font-bold text-slate-950 transition-colors"
        >
          <RefreshCw className="h-4 w-4" />{t('muatUlang')}
        </button>
      </div>
    </div>
  );
}
